import React from 'react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column', gap: '12px' }}>
      <div style={{ fontSize: '48px', fontWeight: '700', color: '#e5e5e5' }}>404</div>
      <div style={{ fontSize: '16px', fontWeight: '600' }}>Page not found</div>
      <button style={{ marginTop: '8px', padding: '8px 18px', background: '#fd5f0d', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}
        onClick={() => navigate('/')}>Go to Dashboard</button>
    </div>
  );
}

export default NotFound;
